import { render, staticRenderFns } from "./model-view.vue?vue&type=template&id=074a9df8&scoped=true&"
import script from "./model-view.vue?vue&type=script&lang=ts&"
export * from "./model-view.vue?vue&type=script&lang=ts&"
import style0 from "./model-view.vue?vue&type=style&index=0&id=074a9df8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074a9df8",
  null
  
)

export default component.exports